export default __webpack_public_path__ + "static/media/Red0006.b1274e20.png";